import React, { useState } from 'react';
import './FilledInput.css'; // Same CSS for consistent styling
import './Dropdown.css';
import caretIcon from '../assets/caret-icon.svg';

interface DropdownProps {
  id: string;
  label: string;
  options: string[];
  inputChange?: (e: any) => void;
}

const Dropdown: React.FC<DropdownProps> = ({ id, label, options, inputChange }) => {
  const [selected, setSelected] = useState('');

  const handleChange = (e: any) => {
    if(inputChange){
      inputChange(e);
    }
    const newValue = e.target.value;
    setSelected(newValue);
  };

  return (
    <div className="input-wrapper">
      <select
        className="filled-input"
        id={id}
        value={selected}
        style={{ backgroundImage: `url(${caretIcon})` }}
        onChange={handleChange}
      >
        <option value="" disabled>{`${label}`}</option>
        {options.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
